import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import $ from 'jquery'
import React, { Component } from 'react'
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl'
import CalendarSelect from "../calendar/calendarselect.component.jsx"
import ActionButton from "../common/button/actionbutton.component.jsx"
import Icon from "../common/icon/icon.component.jsx"
import { getEventName } from '../name-helpers/eventNameHelper'
import { getNylasVersion } from '../utils/common/utils'

const messages = defineMessages({
    "title_placeholder": {
        id: 'scheduling_page.modal.creation.event_title_placeholder',
        defaultMessage: 'i.e: Title of your {eventName}',
    },
    "location_placeholder": {
        id: 'scheduling_page.modal.creation.location_placeholder',
        defaultMessage: 'The location can be a physical address, an URL to an online meeting, etc.',
    },
})

class NewSchedulingPageModal extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            modalId: this.props.modalId || 'scheduling-page-creation-modal',
            title: '',
            locationName: '',
            availabilityCalendarIds: [],
            bookingCalendarIds: [],
        }
        this.handleCloseModal = this.handleCloseModal.bind(this)
        this.save = this.save.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.setLocation = this.setLocation.bind(this)

    }

    componentDidMount() {
        $('#' + this.state.modalId).modal('show')
    }

    handleCloseModal(event) {
        event.preventDefault()
        this.closeModal()
    }

    closeModal(listId) {
        $('#' + this.state.modalId).modal('hide')
        if (this.props.onClose) {
            this.props.onClose(listId)
        }
    }

    save(event) {
        event.preventDefault()
        const nylasKey = getNylasVersion()
        return AppContext.getApiClient().post(`/${nylasKey}/scheduling-pages`, {
            title: this.state.title,
            locationName: this.state.locationName,
            availabilityCalendarIds: this.state.availabilityCalendarIds,
            bookingCalendarIds: this.state.bookingCalendarIds,
        }).then(list => {
            this.closeModal(list.id)
        })
    }

    handleFormChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    setLocation(event) {
        event.preventDefault()
        this.setState({
            locationName: event.target.value,
        })
    }

    render() {
        return (
            <form className="needs-validation" noValidate id="scheduling-page-form-creation-modal">
                <div className="modal"
                    id={this.state.modalId}
                    role="dialog"
                    aria-labelledby={this.state.modalId + "Label"}
                    aria-hidden="true"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <div className="modal-dialog modal-signature" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <div className="modal-title h5" id={this.state.modalId + "Label"}>
                                    <FormattedMessage
                                        id="scheduling_page.modal.creation.title"
                                        defaultMessage="Create a scheduling page"
                                    />
                                </div>
                            </div>
                            <div className="modal-body py-0">
                                <div className="container-fluid">
                                    <div className="form-group row mt-3 mb-0">
                                        <label htmlFor="availabilityCalendarIds" className="col-lg-3 col-12 col-form-label">
                                            <FormattedMessage
                                                id="common.scheduling_page.modal.calendar_availability_label"
                                                defaultMessage="Calendar(s)"
                                            /> <span className="text-danger">*</span>
                                        </label>
                                        <div className="col-lg-9 col-12">
                                            <CalendarSelect
                                                onePerExternalAccount={true}
                                                onChange={availabilityCalendarIds => {
                                                    this.setState({ availabilityCalendarIds })
                                                }} />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <small className="form-text text-muted pl-3">
                                            <FormattedMessage
                                                id="common.scheduling_page.modal.calendar_availability_description"
                                                defaultMessage="
                                                By choosing more than one calendar, it's possible to book a time slot multiple times. For example, with two calendars, a single time slot can be reserved twice (once for each calendar).
                                                "
                                            />
                                        </small>
                                    </div>
                                    {/* Uncomment the code below to allow the selection of calendars for booking (can be different from the selected calendars for availability) */}
                                    {/*  <div className="form-group row mt-3">
                                        <label htmlFor="bookingCalendarIds" className="col-lg-3 col-12 col-form-label">
                                            <FormattedMessage
                                                id="common.scheduling_page.modal.calendar_booking_label"
                                                defaultMessage="Calendar(s) for booking"
                                            /> <span className="text-danger">*</span>
                                        </label>
                                        <div className="col-lg-9 col-12">
                                            <CalendarSelect
                                                onePerExternalAccount={true}
                                                onChange={bookingCalendarIds => {
                                                    this.setState({ bookingCalendarIds })
                                                }} />
                                        </div>
                                    </div> */}
                                    <div className="form-group row mt-3">
                                        <label htmlFor="contactId" className="col-lg-3 col-12 col-form-label">
                                            <FormattedMessage
                                                id="scheduling_page.modal.title_label"
                                                defaultMessage="Title"
                                            /> <span className="text-danger">*</span>
                                        </label>
                                        <div className="col-lg-9 col-12">
                                            <input
                                                value={this.state.title}
                                                onChange={this.handleFormChange}
                                                name={'title'}
                                                type="text"
                                                className="form-control"
                                                placeholder={this.props.intl.formatMessage(messages['title_placeholder'],
                                                    { eventName: getEventName(this.props.intl) })}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row mt-3">
                                        <label htmlFor="location" className="col-lg-3 col-12 col-form-label">
                                            <FormattedMessage
                                                id="common.scheduling_page.modal.location_label"
                                                defaultMessage="Location"
                                            /> <span className="text-danger">*</span>
                                        </label>
                                        <div className="col-lg-9 col-12">
                                            <textarea
                                                name="locationName"
                                                value={this.state.locationName}
                                                onChange={this.setLocation}
                                                id="locationName"
                                                rows="3"
                                                className="form-control"
                                                placeholder={this.props.intl.formatMessage(messages["location_placeholder"])}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={this.handleCloseModal}>
                                    <FormattedMessage
                                        id="common.scheduling_page.modal.close_btn"
                                        defaultMessage="Close"
                                    />
                                </button>
                                <ActionButton className="btn btn-primary" onClick={this.save} disabled={
                                    !this.state.title ||
                                    this.state.availabilityCalendarIds.length === 0 ||
                                    !this.state.locationName}>
                                    <Icon value={"calendar-day"} className={"mr-1"} />
                                    <FormattedMessage
                                        id="common.scheduling_page.modal.confirm_btn"
                                        defaultMessage="Create scheduling page"
                                    />
                                </ActionButton>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default injectIntl(NewSchedulingPageModal)





// WEBPACK FOOTER //
// ./src/scheduling-page/newmodal.component.jsx